<template>
    <v-flex  pa-5>
        <v-card >
            <v-toolbar dark color="primary">
                <v-toolbar-title>Submit Outing!</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex  >
                        <h2>Team</h2>
                        <v-select
                                v-model="form.team"
                                :items="activeTeamsForSelect"
                                label=Team
                                item-text=name
                                item-value=id
                                @change="onTeamChange($event)"
                                outline
                        ></v-select>
                        <h2>Date</h2>
                        <v-date-picker @change="onDateChange($event)" color="green lighten-1" v-model="form.date"></v-date-picker>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex  pa-3>
                            <h2>Team Results</h2>
                            <v-layout  v-for="i in 4" row>
                                <v-flex md4 xs12>
                                    <v-layout row >
                                        <v-container justify-center>
                                            {{getLabelForResult(i)}}
                                        </v-container>
                                        <v-radio-group row v-model="form.results[i-1]">
                                            <v-layout>
                                                <v-flex>
                                                    <v-radio value="W" label="W"></v-radio>
                                                </v-flex>

                                                <v-flex>
                                                    <v-radio value="L" label="L"></v-radio>
                                                </v-flex>
                                                <v-flex>
                                                    <v-radio value="T" label="T"></v-radio>
                                                </v-flex>
                                            </v-layout>
                                        </v-radio-group>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                    </v-flex>
                </v-layout>

                <v-layout row>
                    <v-flex>
                        <h2 >Individual Results</h2>
                        <v-flex >
                            <v-layout row v-for="(bowler, index) in bowler_spots" :key="bowler" mb-5 mt-5 >
                                <v-layout wrap >
                                    <v-flex px-2 md3 xs12>
                                        <v-select  item-value=id
                                                   item-text=name
                                                   :items="activeBowlersForSelect"
                                                   :label="getBowlerString(index)"
                                                   v-model="form.bowlers[index].id"
                                                   outline >
                                        </v-select>
                                    </v-flex>
                                    <v-flex px-2 v-for="i in 3" :key="i" md2 xs4>
                                        <v-text-field
                                                v-model="form.bowlers[index].scores[i - 1]"
                                                :label="'Game '+ i" placeholder="0"
                                                outline :rules="nameRules"
                                                required
                                                type="number"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-layout>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex>
                        <h2 >Team Adjustments</h2>
                        <v-flex >
                            <v-layout wrap mt-5>
                                <v-flex px-2  md2 xs4>
                                    <v-text-field
                                            v-model="form.additionalScratch"
                                            label="Adjusted Scratch Pins (per game)"
                                            outline :rules="nameRules"
                                            required
                                            type="number"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex px-2  md2 xs4>
                                    <v-text-field
                                            v-model="form.additionalHdcp"
                                            label="Adjusted HDCP Pins (per game)"
                                            outline :rules="nameRules"
                                            required
                                            type="number"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-card-text>

            <v-card-actions>
                <v-layout column>
                    <v-btn color="primary" :disabled="isDisabled" @click="submit">Submit</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-flex>
</template>

<script>
    import axios from "axios";
    export default {
       name: 'submit-outing',
       data() {
          return {
             valid: false,
             nameRules: [
                (v) => /^[0-9]+$/.test(v) || 'Must be a bowling score',
                (v) => v <= 300 || "No way Jose"
             ],
             bowler_spots: [1, 2, 3, 4],
             picker: new Date().toISOString().substr(0, 10),
             form: {
                team: null,
                date: null,
                results: [null, null, null, null],
                bowlers: [
                   {
                      id: null,
                      scores: [null, null, null]
                   },
                   {
                      id: null,
                      scores: [null, null, null]
                   },
                   {
                      id: null,
                      scores: [null, null, null]
                   },
                   {
                      id: null,
                      scores: [null, null, null]
                   }
                ],
                additionalScratch: null,
                additionalHdcp: null
             }
          }
       },
       methods: {
          getLabelForResult(i) {
             return (i == 4) ? "Totals" : "Game: " + i;
          },
          submit() {
             this.$refs.form.validate()
          },
          clear() {
             this.$refs.form.reset()
          },
          getBowlerString: function (i) {
             return "Bowler " + (i + 1).toString();
          },
          submitTeam(){
             const endpoint =
                "https://nostyleguy.com/api/team_outings/" +
                this.form.team.toString();
             const body = {
                team_id: this.form.team,
                date: this.form.date,
                game1: this.form.results[0],
                game2: this.form.results[1],
                game3: this.form.results[2],
                totals: this.form.results[3],
                additional_scratch: this.form.additionalScratch,
                additional_hdcp: this.form.additionalHdcp
             };
             axios({
                method: "POST",
                url: endpoint,
                data: body,
                headers: {
                   "content-type": "application/json"
                }
             }).then(
                result => {
                   console.log(JSON.stringify(result.data));
                },
                error => {
                   console.log(error);
                }
             );
          },
          submitBowler(i) {
             let bowler = this.form.bowlers[i];
             const endpoint =
                "https://nostyleguy.com/api/bowler_history/" + bowler.id.toString();
             const body = {
                bowler_id: bowler.id,
                team_id: this.form.team,
                date: this.form.date,
                game1: bowler.scores[0],
                game2: bowler.scores[1],
                game3: bowler.scores[2]
             };
             axios({
                method: "POST",
                url: endpoint,
                data: body,
                headers: {
                   "content-type": "application/json"
                }
             }).then(
                result => {
                   console.log(JSON.stringify(result.data));
                },
                error => {
                   console.log(error);
                }
             );
          },
          submit() {
             this.submitTeam();
             let valid = true;
             valid &= this.form.team !== null;
             valid &= this.form.date !== null;
             for (let b in this.form.bowlers) {
                let bowler = this.form.bowlers[b];
                valid &= bowler.id != null;
                for (let s in bowler.scores) {
                   let score = bowler.scores[s];
                   valid &= score !== null;
                }
             }

             for (let i in this.form.bowlers) {
                if (this.form.bowlers[i].id) {
                   this.submitBowler(i);
                }
             }
          },
          dbBowlerToFrontendBowler(b){
             return {
                name: b.first_name + " " + b.last_name,
                id: b.id,
                active: b.active,
             }
          },
          dbTeamToFrontendTeam(t){
             return {
                name: `${t.name} (${t.year} ${t.season})`,
                id: t.id
             }
          },
          onTeamChange(value){
            this.$store.commit("gameeditor_set_team", value)
         },
         onDateChange(value){
            this.$store.commit("gameeditor_set_date", value)
         }
       },
       computed: {
          isDisabled() {
             return false;
          },
          activeBowlersForSelect() {
             return this.$store.getters.activeBowlers.map(this.dbBowlerToFrontendBowler);
          },
          activeTeamsForSelect() {
             console.log("Transforming teams: " +
                this.$store.getters.activeTeams.length);
             return this.$store.getters.activeTeams.map(this.dbTeamToFrontendTeam);
          }
       },
       mounted: async function(){
          this.$store.dispatch('getTeams');
          this.$store.dispatch('getBowlers');
          this.form.team = this.$store.state.currentGameEditorSettings.team;
          this.form.date = this.$store.state.currentGameEditorSettings.date;
       }
    }
</script>

<style scoped>
.flex-center {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>